<template>
  <button
    class="bcc-button"
    :disabled="disabled"
    @click="handleClick"
    :class="['bcc-button--' + type,
    {'is-disabled': disabled},
    size]"
  >
  <div class="prefix-icon" v-if="prefixIcon">
    <i :class="prefixIcon"></i>
  </div>
  <span v-if="$slots.default"><slot></slot></span>
  </button>
</template>
<script>
export default {
  name: 'BccButton',
  componentName: 'BccButton',
  props: {
    disabled: {
      type: Boolean,
      default () {
        return false
      }
    },
    type: {
      type: String,
      default () {
        return 'default'
      }
    },
    size: {
      type: String,
      default () {
        return 'small'
      }
    },
    prefixIcon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick (evt) {
      this.$emit('click', evt)
    }
  }
}
</script>
